import { DateTools } from '@treezor/design-system';

import { IGetOperationsReport, IWalletOperationDownload } from '@/features/wallets/store/models/walletOperation.model';

export const WalletTools = {
  buildOperationsParams: (
    { dateFrom, dateTo }: { dateFrom: string; dateTo: string },
    file: IGetOperationsReport,
    params?: IWalletOperationDownload,
  ): IWalletOperationDownload => {
    const newDate = DateTools.now().getTime();
    const baseOperationsInfo = {
      dateFrom: params?.dateFrom ?? dateFrom,
      dateTo: params?.dateTo ?? dateTo,
      createdAt: params?.createdAt ?? newDate,
    };

    const duration = DateTools.getDuration(DateTools.createDate(baseOperationsInfo.createdAt)) / 60;

    if (file.status === 'CREATED') {
      return {
        ...baseOperationsInfo,
        status: 'PENDING',
      };
    } else if (file.status === 'COMPLETED') {
      return {
        ...baseOperationsInfo,
        status: 'COMPLETED',
        url: file.url,
      };
    } else if (!file && duration > 15) {
      return {
        ...baseOperationsInfo,
        status: 'CANCELED',
      };
    } else {
      return {
        ...baseOperationsInfo,
        status: 'NO_REQUEST',
      };
    }
  },
};
